import { render, staticRenderFns } from "./shuxuejisuan.vue?vue&type=template&id=492da1d2&"
import script from "./shuxuejisuan.vue?vue&type=script&lang=js&"
export * from "./shuxuejisuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports